import { matchPath, useLocation } from "common/src/router/compat";
import { useTranslation } from "react-i18next";
import logo18 from "common/src/assets/img/logo_18.svg";
import FooterLinks from "./FooterLinks";
import {
  FooterWrapper,
  FooterLinksWrapper,
  FooterBottomSection,
  StyledFooterBootom,
  StyledTrustlyline,
  Logo18,
  FotterLicences,
  Copyrightght,
  PUBFooterImg,
  CacSectionWrapper,
  PUBFooterImgSafari,
} from "../styledComponents/StyledFooter";
import { NewsButtonWrapper } from "../styledComponents/StyledNews";
import React, { lazy, Suspense, useEffect, useState } from "react";
import { StyledFader } from "../styledComponents/StyledIndex";
import { StyledProviderLogo } from "../styledComponents/StyledGame";

const PaymentMethods = lazy(() => import("./PaymentMethods"));
const GameProvidersList = lazy(() =>
  import("./GameProvidersList").then((mod) => ({
    default: mod.GameProvidersList,
  })),
);
// Licence/award logos are large inline SVG components (~185 KiB of JS): own chunk.
const LicensesList = lazy(() =>
  import("./LicensesList").then((mod) => ({
    default: mod.LicensesList,
  })),
);
import FooterText from "./FooterText";
import { DividerPub } from "../styledComponents/StyledSlider";
import { THEME } from "../helpers/constants";
import { browserVersion, isMobileSafari, isSafari } from "react-device-detect";

const Footer = ({
  currentTheme,
  setTheme,
  serverSetup,
  gameCategories,
  pages,
  setSearchResults,
  accountRoute,
  player,
  setSpinner,
  setSelectedCategory,
  config,
  imgAndDevider,
  trastlyline,
  styleOne,
  styleTwo,
  logoFooter,
  footerText,
  providerBg,
  setSelectedProvider,
  inGame,
  footerHide,
  providerPageKeys,
}) => {
  const { t, i18n } = useTranslation("");
  let location = useLocation();
  const baseUrl = `/${
    i18n.language || window.localStorage.i18nextLng || config.defaultLang
  }`;
  const [forcePng, setForcePng] = useState(false);

  useEffect(() => {
    if ((isMobileSafari || isSafari) && parseInt(browserVersion) < 14)
      setForcePng(true);
  }, []);

  const isPubLobbyPage =
    config.skin === "pub" && location.pathname === pages["index"];

  let noTopBorderOnGames = "footer-padding";
  if (
    location.pathname === `${baseUrl}/games` ||
    isPubLobbyPage ||
    matchPath(location.pathname, gameCategories) ||
    location.pathname === `${baseUrl}/withdrawal`
  ) {
    noTopBorderOnGames = "footer-padding-game";
  }

  const switchTheme = () => {
    const nextTheme = currentTheme === "light" ? "dark" : "light";
    setTheme(nextTheme);
    document.documentElement.setAttribute("data-theme", nextTheme);
    localStorage.setItem(THEME, nextTheme);
  };

  document.documentElement.setAttribute("data-theme", currentTheme);

  return (
    <FooterWrapper
      game={
        location.pathname === `${baseUrl}/games` ||
        isPubLobbyPage ||
        location.pathname === `${baseUrl}/lp-roulette` ||
        matchPath(location.pathname, gameCategories) ||
        location.pathname === `${baseUrl}/withdrawal`
      }
    >
      {!styleTwo && (
        <FooterLinksWrapper>
          {imgAndDevider &&
            (forcePng ? <PUBFooterImgSafari /> : <PUBFooterImg />)}
          {imgAndDevider && <DividerPub footer />}
          <FooterLinks
            player={player}
            pages={pages}
            skin={config.skin}
            switchTheme={switchTheme}
            currentTheme={currentTheme}
            server={serverSetup}
            footerHide={footerHide}
            providerPageKeys={providerPageKeys}
          />
        </FooterLinksWrapper>
      )}
      {styleOne && (
        <StyledFader>
          <Suspense fallback={null}>
            <PaymentMethods
              currentTheme={currentTheme}
              pages={pages}
              serverSetup={serverSetup}
              currentLanguage={serverSetup.currentLanguage}
              skin={config.skin}
              paymentsImagePath={config.paymentsImagePath}
            />
          </Suspense>
        </StyledFader>
      )}
      {styleOne && (
        <StyledProviderLogo background={providerBg}>
          <Suspense fallback={null}>
            <GameProvidersList
              currentTheme={currentTheme}
              serverSetup={serverSetup}
              skin={config.skin}
              vendorsImagePath={config.vendorsImagePath}
              setSearchResults={setSearchResults}
              accountRoute={accountRoute}
              setSpinner={setSpinner}
              setSelectedCategory={setSelectedCategory}
              setSelectedProvider={setSelectedProvider}
              pages={pages}
              inGame={inGame}
            />
          </Suspense>
        </StyledProviderLogo>
      )}
      {styleOne && !inGame && !footerHide && (
        <FooterText
          skin={config.skin}
          pages={pages}
          providerPageKeys={providerPageKeys}
        />
      )}
      {styleTwo && (
        <CacSectionWrapper>
          <FooterLinksWrapper>
            <FooterLinks
              player={player}
              pages={pages}
              skin={config.skin}
              switchTheme={switchTheme}
              currentTheme={currentTheme}
              server={serverSetup}
              footerHide={footerHide}
              providerPageKeys={providerPageKeys}
            />
          </FooterLinksWrapper>
          <FooterText
            skin={config.skin}
            pages={pages}
            providerPageKeys={providerPageKeys}
          />
        </CacSectionWrapper>
      )}
      <FooterBottomSection>
        <StyledFooterBootom>
          <NewsButtonWrapper>
            <StyledTrustlyline>
              {logoFooter && (
                <Logo18>
                  <img alt="" src={logo18} height="40px" />
                  <div
                    dangerouslySetInnerHTML={{
                      __html: t(
                        "label_footer-text-top",
                        `Gambling can be addictive, <br>play responsibily</br>`,
                      ),
                    }}
                  ></div>
                </Logo18>
              )}
              {footerText && (
                <FooterText skin={config.skin} companyInfo={true} />
              )}
              <FotterLicences background={providerBg}>
                <Suspense fallback={null}>
                  <LicensesList skin={config.skin} />
                </Suspense>
              </FotterLicences>

              <Copyrightght>
                <p
                  dangerouslySetInnerHTML={{
                    __html: t("label_text_copyright"),
                  }}
                ></p>
                <p>&middot;</p>{" "}
                <p
                  dangerouslySetInnerHTML={{
                    __html: t("label_footer_text_bottom"),
                  }}
                ></p>
              </Copyrightght>
            </StyledTrustlyline>
          </NewsButtonWrapper>
        </StyledFooterBootom>
      </FooterBottomSection>
    </FooterWrapper>
  );
};

export default Footer;
